import { useRef, ReactNode } from 'react';

import { Collapse } from '@rockalingua/ui';

import { Container, FAQsContainer, TitleContainer } from './FAQs.styled';

export type FAQItem = {
  id: string;
  question: string | ReactNode;
  answer: string | ReactNode;
};

export type FAQsProps = {
  title?: ReactNode;
  items: FAQItem[];
  onFaqOpen: (faqId: string) => void;
  image?: ReactNode;
};

export default function FAQs({ title, items, onFaqOpen, image }: FAQsProps) {
  const previousActiveKeys = useRef<string[]>([]);

  const handleChange = (activeKeys: string | string[]) => {
    const nextKeys = Array.isArray(activeKeys) ? activeKeys : [activeKeys];
    const prevKeys = previousActiveKeys.current;
    const newlyOpened = nextKeys.find((key) => !prevKeys.includes(key));

    if (newlyOpened) {
      onFaqOpen(newlyOpened);
    }

    previousActiveKeys.current = nextKeys;
  };

  return (
    <Container>
      {image}
      <FAQsContainer>
        {title && <TitleContainer>{title}</TitleContainer>}
        <Collapse onChange={handleChange}>
          {items.map((faq) => (
            <Collapse.Panel key={faq.id} header={faq.question}>
              {faq.answer}
            </Collapse.Panel>
          ))}
        </Collapse>
      </FAQsContainer>
    </Container>
  );
}
